import { IconCloudUpload, IconRefresh, IconCircleCheckFilled, IconCircleXFilled } from '@tabler/icons-react';
import PropTypes from 'prop-types';

import { EXPORT_JOB_STATUS, EXPORT_JOB_STATUS_TO_LABEL } from '../../core/constants';

const getJobIcon = (status) => {
  switch (status) {
    case EXPORT_JOB_STATUS.notStarted:
      return <IconCloudUpload size={24} className="text-gray-500" />;
    case EXPORT_JOB_STATUS.processing:
      return <IconRefresh size={24} className="text-orange-300" />;
    case EXPORT_JOB_STATUS.done:
      return <IconCircleCheckFilled size={24} className="text-green-400" />;
    case EXPORT_JOB_STATUS.failed:
      return <IconCircleXFilled size={24} className="text-red-500" />;
    default:
      return null;
  }
};

const ExportStatus = ({ status }) => {
  return (
    <div className="flex items-center space-x-3">
      {getJobIcon(status)}
      <p>{EXPORT_JOB_STATUS_TO_LABEL[status]}</p>
    </div>
  );
};

ExportStatus.propTypes = {
  status: PropTypes.string.isRequired,
};

export default ExportStatus;
